import { useMemo } from "react";

import { Blueprint } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";
import { BlueprintSuggestions } from "shared/Blueprint/constants";

import useCellFilterAction from "../useCellFilterAction";

const BlueprintsTableSpaceCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  const spaceFilterAction = useCellFilterAction({
    filterName: BlueprintSuggestions.Space,
    filterValue: blueprint.space.id,
    spaceCell: true,
  });

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <SpacePath spaceId={blueprint.space.id} fallbackName={blueprint.space.name} />
    </TableSimpleCell>
  );
};

export default BlueprintsTableSpaceCell;
